import DefaultBenchmarkSwitch from 'components/DefaultBenchmarkSwitch/DefaultBenchmarkSwitch';

export default DefaultBenchmarkSwitch;
